import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useTransactionPix = (id) => useQuery({ queryKey: [`transaction`, id], queryFn: async () => {
    if(!id) return {}
    const callback = await API.get(`/transactions/${id}/pix`)
    return callback?.data
}, staleTime: 1000 * 60, gcTime: 0})

export default useTransactionPix